(function (TIPTOE, w, d, $) {
  $(w).on('load', function () {
    init();
  });

  /**
   *
   */
  function init() {
    const $popInInfoPaiement = $('#js-popin-info-payment');

    // Open the pop-in on click
    $('.open-payment-info').on('click', openPopinInfoPayment);

    // Close the pop-in
    $('.close-popin-info-payment').on('click', closePopinPaiement);

    // Close on echap
    $(document).keyup(function (e) {
      if (e.keyCode == 27) {
        closePopinPaiement();
      }
    });

    /**
     *
     */
    function openPopinInfoPayment(e) {
      $popInInfoPaiement.addClass('is-visible');

      setTimeout(function () {
        $(document.body).on('click', closePopinPaiement);
      }, 0);
    }

    /**
     *
     */
    function closePopinPaiement() {
      $(document.body).off('click');
      $popInInfoPaiement.removeClass('is-visible');
    }
  }

  // To fix the cart update that removes the listener we expose a function
  // to the global scope so the `cartInit()` can force refresh it.
  window.forceRefreshPaymentInfo = init;
})(TIPTOE, window, document, jQuery);
